module.exports = __webpack_public_path__ + "img/christmas-morning-crock-pot-french-toast.f80eabae.jpg";